/* src/app/modules/coils/components/coil-history/coil-history.component.scss */
:host {
  --functional-green:
    18,
    135,
    46;
  --functional-red:
    200,
    44,
    41;
}
api-call-gate {
  display: initial;
}
.channel-api-call {
  grid-column-end: 9;
  grid-column-start: 1;
}
section {
  padding-top: 0.6rem;
  margin-left: 0.1rem;
  display: flex;
}
section sh-toggle {
  gap: 0.5rem;
}
section .toggle-style {
  width: fit-content;
  white-space: nowrap;
  margin-top: 0.2rem;
}
.dates-grid {
  display: grid;
  grid-template: repeat(1, 1fr)/0.5fr repeat(7, 1fr);
  margin-top: 1rem;
  place-items: center;
  margin-bottom: 1rem;
  grid-row-gap: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1019607843);
  padding-bottom: 1.5rem;
}
.dates-grid .colored-circles {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.show-more-channels-row {
  grid-column: 1/-1;
  margin-left: 3rem;
  text-decoration: underline;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 0.5rem;
}
.day-of-month {
  padding: 0.2rem 0.3rem;
  border-radius: 0.8rem;
  position: relative;
  height: min-content;
}
.day-of-week {
  color: var(--text-secondary);
  position: absolute;
  top: -1.7rem;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 0.2;
  padding-top: 8px;
}
.coil-element-text {
  position: relative;
  width: 0;
}
.coil-element-text:not(.last-row)::after {
  content: "";
  position: absolute;
  width: 38vw;
  border-bottom: 1px solid #d3d3d3;
  top: 1.44rem;
  left: 0rem;
}
[screen-tablet] :host-context .dates-grid {
  margin-left: -3rem;
}
[screen-tablet] :host-context .coil-element-text {
  margin-left: 3rem;
}
[screen-tablet] :host-context .coil-element-text::after {
  width: 89vw;
}
[screen-tablet] :host-context .show-more-channels-row {
  margin-left: 6rem;
}
.date-with-icon {
  display: flex;
  align-items: center;
}
.date-with-icon sh-icon {
  margin-right: 0.1rem;
  color: white;
  padding: 0;
}
.first-week-div,
.second-week-div {
  display: flex;
  flex-direction: column;
}
.bigger-circles-phone {
  width: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}
.icon-phone {
  color: white;
}
.full-week {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}
.full-week-container {
  margin-left: 0.5rem;
}
.day-of-week-phone {
  position: absolute;
  left: 5rem;
  display: flex;
  align-items: center;
  width: 67vw;
  font-size: 1.125rem;
}
.day-of-week-phone::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 3%;
  transform: translateX(-21%);
  width: 126%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1019607843);
  margin-bottom: -7px;
}
.day-of-week-phone .status-count {
  position: absolute;
  margin-inline-start: 11rem;
  color: #666666;
}
.day-of-week-phone sh-icon {
  margin-left: auto;
}
/*# sourceMappingURL=coil-history.component.css.map */
